<template>
  <div class="mt-5">
    <br />
    <br />
    <br />
    <div class="row">
      <div class="col-12 mb-2">
        <button @click="refresh()" class="btn ms-auto btn0 btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
        </button>
      </div>
    </div>

    <!-- ═══════ KPI DU JOUR ═══════ -->
    <div v-if="hasCalculationErrors" class="row mb-3">
      <div class="col-12">
        <div class="calculation-error-banner">
          <div class="calculation-error-header">
            <i class="bi bi-exclamation-triangle-fill"></i>
            <div>
              <h6>Erreurs de calcul clients detectees</h6>
              <p>
                Certains clients ont des ecarts entre les paiements, les
                affectations et les ventes payees.
              </p>
            </div>
          </div>
          <div class="calculation-error-grid">
            <div
              v-for="(row, index) in calculationErrorRows"
              :key="'calc-error-' + index"
              class="calculation-error-metric"
              :class="{ danger: row.danger }"
            >
              <span>{{ row.label }}</span>
              <strong>{{ formatAmount(row.value) }}</strong>
            </div>
          </div>
          <div class="calculation-error-meta">
            <span>
              Clients avec erreur:
              <strong>{{
                calculationErrorCustomers.length ||
                calculationError.customersCount ||
                0
              }}</strong>
            </span>
            <span>
              Paiements sans factures:
              <strong>{{ calculationError.orphanPaymentsCount || 0 }}</strong>
            </span>
            <span>
              Ventes avec ecart:
              <strong>{{
                calculationError.salesWithPaymentMismatchCount || 0
              }}</strong>
            </span>
          </div>
          <div
            v-if="calculationErrorCustomers.length"
            class="calculation-error-customers"
          >
            <div class="calculation-error-table-title">
              Clients avec erreur:
              <strong>{{ calculationErrorCustomers.length }}</strong>
            </div>
            <div class="table-responsive">
              <table class="table table-sm align-middle mb-0">
                <thead>
                  <tr>
                    <th>Client</th>
                    <th>Type d'erreur</th>
                    <th class="text-end">Paiements</th>
                    <th class="text-end">Affecte</th>
                    <th class="text-end">Ventes payees</th>
                    <th class="text-end">Ecart affecte</th>
                    <th class="text-end">Sans facture</th>
                    <th class="text-end">Ventes erreur</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="customer in calculationErrorCustomers"
                    :key="customer.customer_reference"
                  >
                    <td>
                      <router-link
                        v-if="customer.customer_reference"
                        class="calculation-error-customer-link fw-bold"
                        :to="{
                          name: 'customers-details',
                          params: { reference: customer.customer_reference },
                        }"
                      >
                        {{ customer.customerName }}
                      </router-link>
                      <div v-else class="fw-bold">
                        {{ customer.customerName }}
                      </div>
                      <small>{{ customer.customer_reference }}</small>
                    </td>
                    <td>
                      <div class="calculation-error-issues">
                        <span
                          v-for="issue in getCustomerCalculationIssues(customer)"
                          :key="customer.customer_reference + '-' + issue"
                          class="calculation-error-issue"
                        >
                          {{ issue }}
                        </span>
                      </div>
                    </td>
                    <td class="text-end">
                      {{ formatAmount(customer.paymentTotal) }}
                    </td>
                    <td class="text-end">
                      {{ formatAmount(customer.allocatedPaymentTotal) }}
                    </td>
                    <td class="text-end">
                      {{ formatAmount(customer.saleAmountPaidTotal) }}
                    </td>
                    <td class="text-end fw-bold text-danger">
                      {{ formatAmount(customer.allocatedVsSalesPaidDifference) }}
                    </td>
                    <td class="text-end">
                      {{ customer.orphanPaymentsCount || 0 }}
                    </td>
                    <td class="text-end">
                      {{ customer.salesWithPaymentMismatchCount || 0 }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="true" class="row g-3 mb-2">
      <div v-for="(card, i) in kpiCards" :key="'kpi-' + i" class="col-6 col-sm-4 col-lg-2">
        <div class="kpi-card" :style="'--kpi-color:' + card.hex">
          <div class="kpi-icon"><i :class="card.icon"></i></div>
          <div class="kpi-body">
            <span class="kpi-label">{{ card.label }}</span>
            <span class="kpi-value">{{ card.value | formatWithSpaces }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ═══════ COMMANDES DU JOUR ═══════ -->
    <div v-show="true" class="row g-3 mb-2">
      <div v-for="(card, i) in orderDayCards" :key="'oday-' + i" class="col-6 col-sm-4 col-lg-3">
        <div class="dashboard-card" :class="'text-' + card.color">
          <div class="icon-wrapper" :class="'bg-' + card.color + '-light'">
            <i :class="card.icon"></i>
          </div>
          <div class="info">
            <h6>{{ card.title }}</h6>
            <h4>{{ card.value | formatWithSpaces }}</h4>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard-cards">
      <div
        v-show="true"
        class="row g-3"
      >
        <div
          v-for="(card, index) in orderCards"
          :key="'order-' + index"
          class="col-12 col-sm-6 col-lg-3"
        >
          <div class="dashboard-card" :class="'text-' + card.color">
            <div class="icon-wrapper" :class="'bg-' + card.color + '-light'">
              <i :class="[card.icon]"></i>
            </div>
            <div class="info">
              <h6>{{ card.title }}</h6>
              <h4>{{ card.value | formatWithSpaces }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div
        v-show="true"
        class="row g-3 mt-3"
      >
        <div
          v-for="(card, index) in totalOrderCards"
          :key="'total-' + index"
          class="col-12 col-sm-6 col-lg-3"
        >
          <div class="dashboard-card" :class="'text-' + card.color">
            <div class="icon-wrapper" :class="'bg-' + card.color + '-light'">
              <i :class="[card.icon]"></i>
            </div>
            <div class="info">
              <h6>{{ card.title }}</h6>
              <h4>{{ card.value | formatWithSpaces }}</h4>
            </div>
          </div>
        </div>
      </div>

      <!-- Solde en caisse Cards -->
      <div
        v-show="true"
        class="row g-3 mt-3"
      >
        <div class="col-12 col-sm-6 col-lg-3">
          <div class="dashboard-card text-success">
            <div class="icon-wrapper bg-success-light">
              <i class="bi bi-wallet2"></i>
            </div>
            <div class="info">
              <h6>Solde en caisse</h6>
              <h4>{{ soldeEnCaisse | formatWithSpaces }}</h4>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-3">
          <div class="dashboard-card text-info">
            <div class="icon-wrapper bg-info-light">
              <i class="bi bi-calendar-minus"></i>
            </div>
            <div class="info">
              <h6>Caisse hier</h6>
              <h4>{{ caisseHier | formatWithSpaces }}</h4>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-3">
          <div class="dashboard-card text-primary">
            <div class="icon-wrapper bg-primary-light">
              <i class="bi bi-cash-stack"></i>
            </div>
            <div class="info">
              <h6>Règlement aujourd'hui</h6>
              <h4>{{ reglementToday | formatWithSpaces }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div
        v-show="true"
        class="row g-3 mt-3"
      >
        <div
          v-for="(card, index) in paymentCards"
          :key="'payment-' + index"
          class="col-12 col-sm-6 col-lg-3"
        >
          <div class="dashboard-card" :class="'text-' + card.color">
            <div class="icon-wrapper" :class="'bg-' + card.color + '-light'">
              <i :class="[card.icon]"></i>
            </div>
            <div class="info">
              <h6>{{ card.title }}</h6>
              <h4>{{ card.value | formatWithSpaces }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br />
    <div v-show="true" class="row">
      <div class="col-xl-6 col-12 p-1">
        <div class="card border-0 shadow-sm rounded-top-2 overflow-hidden">
          <div
            class="card-header bg-primary text-white py-3 d-flex align-items-center justify-content-between"
          >
            <h6 class="mb-0 fw-bold">
              <i class="bi bi-person-lines-fill me-2"></i>
              Top 10 clients avec crédits impayés
            </h6>
            <span class="badge bg-light text-primary px-3 py-2">
              {{ top10Credits.length }} Clients
            </span>
          </div>

          <div class="card-body p-0">
            <table class="table align-middle mb-0 modern-table">
              <thead class="bg-light">
                <tr>
                  <th class="ps-4 text-secondary fw-semibold">#</th>
                  <th class="text-secondary fw-semibold">Client</th>
                  <th class="text-end text-secondary fw-semibold pe-4">
                    Montant impayé
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(credit, index) in top10Credits"
                  :key="index"
                  class="hover-row"
                >
                  <td class="ps-4 text-muted fw-bold">{{ index + 1 }}</td>
                  <td class="fw-semibold">
                    <i class="bi bi-person-circle text-primary me-2"></i>
                    {{ credit.customerFullName }}
                  </td>
                  <td class="text-end pe-4">
                    <span class="fw-bold text-danger">
                      {{
                        parseFloat(credit.totalUnpaid).toFixed(2)
                          | formatWithSpaces
                      }}
                    </span>
                  </td>
                </tr>
              </tbody>

              <tfoot class="bg-light">
                <tr>
                  <td colspan="2" class="ps-4 fw-bold text-secondary">
                    Total impayé
                  </td>
                  <td class="text-end pe-4">
                    <span class="badge bg-danger text-white fs-6 px-3 py-2">
                      {{
                        parseFloat(top10TotalUnpaidSum).toFixed(2)
                          | formatWithSpaces
                      }}
                    </span>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-12 row p-1">
        <div class="col-8 mx-auto">
          <vue-pie-chart :chart-data="pieChartData" :options="pieChartOptions" />
        </div>
      </div>
    </div>

    <!-- ═══════ ALERTES & INDICATEURS ═══════ -->
    <div v-show="true" class="row g-3 mt-4">
      <div v-for="(card, i) in alertCards" :key="'alert-' + i" class="col-6 col-sm-4 col-lg-3">
        <div class="alert-stat-card" :class="'alert-' + card.type">
          <div class="alert-icon"><i :class="card.icon"></i></div>
          <div class="alert-body">
            <div class="alert-value">{{ card.value | formatWithSpaces }}</div>
            <div class="alert-label">{{ card.label }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- ═══════ CHÈQUES À ÉCHÉANCE + TOP ARTICLES ═══════ -->
    <div v-show="true" class="row mt-4">
      <!-- Chèques à échéance -->
      <div class="col-xl-6 col-12 p-1">
        <div class="card border-0 shadow-sm rounded-top-2 overflow-hidden">
          <div class="card-header bg-warning text-dark py-3 d-flex align-items-center justify-content-between">
            <h6 class="mb-0 fw-bold"><i class="bi bi-calendar-x me-2"></i>Chèques à échéance</h6>
            <span class="badge bg-dark text-white px-3 py-2">{{ filteredChecks.length }} chèques</span>
          </div>
          <div class="card-body p-0" style="max-height:320px;overflow-y:auto">
            <div v-if="!filteredChecks.length" class="text-center text-muted py-4">
              <i class="bi bi-check-circle fs-3 text-success"></i><br>Aucun chèque à échéance
            </div>
            <table v-else class="table align-middle mb-0 modern-table">
              <thead class="bg-light">
                <tr>
                  <th class="ps-3 text-secondary fw-semibold">Client</th>
                  <th class="text-secondary fw-semibold">Banque</th>
                  <th class="text-secondary fw-semibold">Échéance</th>
                  <th class="text-end text-secondary fw-semibold pe-3">Montant</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(chk, i) in filteredChecks" :key="i" class="hover-row">
                  <td class="ps-3 fw-semibold">{{ chk.customerFullName || chk.fullName || '-' }}</td>
                  <td class="text-muted">{{ chk.bank || '-' }}</td>
                  <td><span class="badge bg-warning text-dark">{{ chk.deadline ? chk.deadline.substring(0,10) : '-' }}</span></td>
                  <td class="text-end pe-3 fw-bold text-warning">{{ parseFloat(chk.amount || 0).toFixed(2) | formatWithSpaces }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Top 10 articles vendus -->
      <div class="col-xl-6 col-12 p-1">
        <div class="card border-0 shadow-sm rounded-top-2 overflow-hidden">
          <div class="card-header bg-success text-white py-3 d-flex align-items-center justify-content-between">
            <h6 class="mb-0 fw-bold"><i class="bi bi-award me-2"></i>Top 10 articles vendus</h6>
            <span class="badge bg-light text-success px-3 py-2">{{ quantityAnalytics.length }} articles</span>
          </div>
          <div class="card-body p-0" style="max-height:320px;overflow-y:auto">
            <table class="table align-middle mb-0 modern-table">
              <thead class="bg-light">
                <tr>
                  <th class="ps-3 text-secondary fw-semibold">#</th>
                  <th class="text-secondary fw-semibold">Article</th>
                  <th class="text-end text-secondary fw-semibold pe-3">Qté vendue</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in top10Items" :key="i" class="hover-row">
                  <td class="ps-3 text-muted fw-bold">{{ i + 1 }}</td>
                  <td class="fw-semibold"><i class="bi bi-box-seam text-success me-2"></i>{{ item.fullName }}</td>
                  <td class="text-end pe-3">
                    <span class="fw-bold text-success">{{ item.soldQuantity }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- ═══════ MÉTHODES DE PAIEMENT CE MOIS + ÉVOLUTION CHIFFRE D'AFFAIRES ═══════ -->
    <div v-show="true" class="row mt-4">
      <div class="col-xl-6 col-12 p-1">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-header bg-primary text-white py-3">
            <h6 class="mb-0 fw-bold"><i class="bi bi-pie-chart me-2"></i>Méthodes de paiement — ce mois</h6>
          </div>
          <div class="card-body">
            <div class="d-flex flex-column gap-3">
              <div v-for="(m, i) in paymentMethodsMonth" :key="i" class="payment-method-row">
                <div class="d-flex justify-content-between mb-1">
                  <span class="fw-semibold"><i :class="m.icon + ' me-2'" :style="'color:' + m.color"></i>{{ m.label }}</span>
                  <span class="fw-bold" :style="'color:' + m.color">{{ m.value | formatWithSpaces }} MAD</span>
                </div>
                <div class="progress" style="height:8px">
                  <div class="progress-bar" :style="'width:' + m.pct + '%;background:' + m.color"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-6 col-12 p-1">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-header bg-info text-white py-3">
            <h6 class="mb-0 fw-bold"><i class="bi bi-graph-up me-2"></i>Aujourd'hui — récapitulatif financier</h6>
          </div>
          <div class="card-body">
            <div class="d-flex flex-column gap-2">
              <div v-for="(row, i) in dailyFinancialRows" :key="i"
                class="d-flex align-items-center justify-content-between rounded-3 px-3 py-2"
                :style="i % 2 === 0 ? 'background:#f8f9fa' : ''">
                <span><i :class="row.icon + ' me-2 opacity-75'"></i>{{ row.label }}</span>
                <span class="fw-bold" :class="row.color">{{ row.value | formatWithSpaces }} MAD</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="true" class="row mt-4">
      <div class="col-12 p-1">
        <div class="seller-stats-container">
          <div class="">
            <div class="mx-3">
              <div>
                <h5 class="">Statistiques Vendeurs</h5>
                <p class="">Analyse détaillée du chiffre d'affaires</p>
              </div>
            </div>
          </div>
          <div class="seller-stats-body">
            <div class="seller-stats-filters">
              <div class="filter-group">
                <label class="filter-label">Du</label>
                <input
                  type="date"
                  v-model="sellerStatsFilter.startDate"
                  class="filter-input"
                />
              </div>
              <div class="filter-group">
                <label class="filter-label">Au</label>
                <input
                  type="date"
                  v-model="sellerStatsFilter.endDate"
                  class="filter-input"
                />
              </div>
              <div class="filter-group">
                <label class="filter-label">Vendeur</label>
                <select
                  v-model="sellerStatsFilter.seller_reference"
                  class="filter-select"
                >
                  <option value="">Tous les vendeurs</option>
                  <option
                    v-for="seller in sellersList"
                    :key="seller.reference"
                    :value="seller.reference"
                  >
                    {{ seller.fullName || seller.reference }}
                  </option>
                </select>
              </div>
              <div class="filter-actions">
                <button
                  class="btn-filter btn-primary"
                  @click="applySellerStatsFilter"
                  :disabled="sellerStatsLoading"
                >
                  <span
                    v-if="sellerStatsLoading"
                    class="spinner-border spinner-border-sm me-2"
                  ></span>
                  <i class="bi bi-search me-2"></i>
                  Rechercher
                </button>
                <button
                  class="btn-filter btn-outline"
                  @click="resetSellerStatsFilter"
                  :disabled="sellerStatsLoading"
                >
                  <i class="bi bi-arrow-counterclockwise me-2"></i>
                  Réinitialiser
                </button>
              </div>
            </div>

            <div class="summary-cards">
              <div
                v-for="(card, idx) in sellerStatisticSummaryCards"
                :key="'seller-stat-' + idx"
                class="summary-card"
              >
                <div class="summary-icon">
                  <i :class="card.icon"></i>
                </div>
                <div class="summary-content">
                  <p class="summary-label">{{ card.label }}</p>
                  <h4 class="summary-value">{{ card.value }}</h4>
                </div>
              </div>
            </div>

            <div v-if="sellerStatsLoading" class="loading-state">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Chargement...</span>
              </div>
              <p class="loading-text">
                Chargement des statistiques vendeurs...
              </p>
            </div>
            <div v-else>
              <div v-if="!topSellers.length" class="empty-state">
                <i class="bi bi-inbox"></i>
                <p>Aucun vendeur disponible pour le moment.</p>
              </div>
              <div v-else class="seller-cards-grid">
                <div
                  v-for="(seller, index) in topSellers"
                  :key="seller.reference"
                  class="seller-card-pro"
                >
                  <div class="seller-card-header">
                    <div class="seller-rank-badge">
                      <span class="rank-number">#{{ index + 1 }}</span>
                    </div>
                    <div class="seller-info">
                      <h6 class="seller-name">{{ seller.fullName || "-" }}</h6>
                      <p class="seller-reference">{{ seller.reference }}</p>
                    </div>
                  </div>

                  <div class="seller-stats-content">
                    <div class="stat-row">
                      <div class="stat-box">
                        <div class="stat-icon">
                          <i class="bi bi-people"></i>
                        </div>
                        <div class="stat-details">
                          <span class="stat-label">Clients</span>
                          <span class="stat-value">{{
                            formatInteger(seller.totalCustomers)
                          }}</span>
                        </div>
                      </div>

                      <div class="stat-box">
                        <div class="stat-icon">
                          <i class="bi bi-cash-stack"></i>
                        </div>
                        <div class="stat-details">
                          <span class="stat-label">Solde caisse</span>
                          <span class="stat-value">{{
                            formatAmount(seller.cashBalance)
                          }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="stat-row">
                      <div class="stat-box">
                        <div class="stat-icon">
                          <i class="bi bi-calendar-day"></i>
                        </div>
                        <div class="stat-details">
                          <span class="stat-label">Ventes du jour</span>
                          <span class="stat-value">{{
                            formatAmount(seller.totalPriceToday)
                          }}</span>
                        </div>
                      </div>

                      <div class="stat-box">
                        <div class="stat-icon">
                          <i class="bi bi-bag-check"></i>
                        </div>
                        <div class="stat-details">
                          <span class="stat-label">Payé aujourd'hui</span>
                          <span class="stat-value">{{
                            formatAmount(seller.amountPaidToday)
                          }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="stat-row stat-row-full">
                      <div class="stat-box stat-box-highlight">
                        <div class="stat-icon stat-icon-highlight">
                          <i class="bi bi-currency-dollar"></i>
                        </div>
                        <div class="stat-details">
                          <span class="stat-label">Total ventes TTC</span>
                          <span class="stat-value stat-value-highlight">{{
                            formatAmount(seller.salesTotalPrice)
                          }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="stat-row">
                      <div class="stat-box">
                        <div class="stat-icon">
                          <i class="bi bi-calendar-month"></i>
                        </div>
                        <div class="stat-details">
                          <span class="stat-label">Ventes du mois</span>
                          <span class="stat-value">{{
                            formatAmount(seller.totalPriceMonth)
                          }}</span>
                        </div>
                      </div>

                      <div class="stat-box">
                        <div class="stat-icon">
                          <i class="bi bi-cash-coin"></i>
                        </div>
                        <div class="stat-details">
                          <span class="stat-label">Payé ce mois</span>
                          <span class="stat-value">{{
                            formatAmount(seller.amountPaidMonth)
                          }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="stat-row">
                      <div class="stat-box">
                        <div class="stat-icon">
                          <i class="bi bi-wallet2"></i>
                        </div>
                        <div class="stat-details">
                          <span class="stat-label">Reçu clients</span>
                          <span class="stat-value">{{
                            formatAmount(seller.receivedFromCustomers)
                          }}</span>
                        </div>
                      </div>

                      <div class="stat-box">
                        <div class="stat-icon">
                          <i class="bi bi-exclamation-circle"></i>
                        </div>
                        <div class="stat-details">
                          <span class="stat-label">Impayé</span>
                          <span class="stat-value">{{
                            formatAmount(seller.salesTotalUnpaid)
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />

    <!-- Customers Map -->
    <!-- <div v-show="$userRole == 'Admin'" class="row mt-4">
      <div class="col-6 p-1">
        <customers-map></customers-map>
      </div>
    </div> -->

    <br />
    <br />
    <div
      v-show="true"
      class="dashboard-totals container-fluid py-3"
    >
      <div class="row g-3">
        <div
          class="col-xl-3 col-lg-4 col-md-6 col-sm-12"
          v-for="(section, index) in sections"
          :key="index"
        >
          <div
            class="card border-0 shadow-sm rounded-4 h-100 overflow-hidden section-card"
          >
            <div class="card-body p-3">
              <h6 class="fw-bold text-uppercase text-primary mb-3">
                <i class="bi bi-bar-chart me-2"></i>{{ section.key }}
              </h6>

              <div class="d-flex flex-column gap-2">
                <div
                  v-for="(item, itemIndex) in section.items"
                  :key="itemIndex"
                  class="d-flex align-items-center justify-content-between rounded-3 px-2 py-2 hover-bg"
                >
                  <div class="d-flex align-items-center gap-2">
                    <i :class="item.icon" class="opacity-75"></i>
                    <span>{{ item.label }}</span>
                  </div>
                  <span
                    v-if="totalTodays[section.key]"
                    :class="['fw-semibold', item.color]"
                  >
                    {{
                      totalTodays[section.key][item.value] | formatWithSpaces
                    }}
                  </span>
                  <span v-else class="skeleton shimmer"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
    <div v-show="true" class="row align-items-stratch">
      <div class="col-xl-12">
        <line-chart
          :chart-data="lineChartData"
          :options="lineChartOptions"
        ></line-chart>
      </div>
    </div>
    <br />
    <br />

    <!--  Suivre les quantités vendues pour chaque article  -->
    <div class="row p-1">
      <div class="col-xl-7 col-12">
        <div class="row align-items-end">
          <div class="col-xl-4">
            <label for="">Du</label>
            <input
              type="date"
              v-model="filter.startDate"
              class="form-control"
            />
          </div>
          <div class="col-xl-4">
            <label for="">Au</label>
            <input type="date" v-model="filter.endDate" class="form-control" />
          </div>

          <div class="col-xl-4">
            <label for=""></label>
            <button
              @click="filterQuantityData(filter)"
              class="btn btn-secondary"
            >
              Rechercher
            </button>
          </div>
        </div>
        <br />
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th scope="col" class="text-center" colspan="4">
                Suivre les quantités vendues pour chaque article
              </th>
            </tr>
            <tr>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col" class="text-center"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(quantity, index) in quantityAnalytics" :key="index++">
              <td>
                {{ index }}
              </td>

              <td>
                {{ quantity.fullName }}
              </td>
              <td class="text-end px-3">
                {{ quantity.soldQuantity }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-xl-5 col-12">
        <vue-pie-chart
          :chart-data="soldQuantityChartData"
          :options="soldQuantityChartOptions"
        />
      </div>
    </div>
    <br />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import BarChartVue from "../components/chart/BarChart.vue";
import BarChartSalesTodayVue from "../components/chart/BarChartSalesToday.vue";
import LineChart from "../components/chart/LineChart.vue";
import ScatterChart from "../components/chart/ScatterChart.vue";
import CustomersMap from "../components/cards/CustomersMap.vue";
import moment from "moment";
export default {
  components: {
    BarChartVue,
    ScatterChart,
    LineChart,
    BarChartSalesTodayVue,
    CustomersMap,
  },
  data() {
    const today = moment(new Date()).format("YYYY-MM-DD");
    return {
      sections: [
        {
          key: "sales",
          items: [
            {
              label: "Total Ventes Aujourd'hui",
              icon: "bi bi-cart3",
              value: "priceTotalTTCSale",
              color: "text-primary",
            },
            {
              label: "Total Ventes Payé",
              icon: "bi bi-window-x",
              value: "totalPaidSale",
              color: "text-success",
            },
            {
              label: "Total Ventes Impayé",
              icon: "bi bi-window-dash",
              value: "totalUnpaidSale",
              color: "text-danger",
            },
            {
              label: "Règlement Ventes Impayé",
              icon: "bi bi-cash-stack",
              value: "totalPaidOldBillSale",
              color: "text-warning",
            },
            {
              label: "Ventes Payé Espèces",
              icon: "bi bi-cash",
              value: "totalCashSale",
              color: "text-success",
            },
            {
              label: "Ventes Payé Virements",
              icon: "bi bi-bank",
              value: "totalBankTransferSale",
              color: "text-danger",
            },
            {
              label: "Ventes Payé Chèques",
              icon: "bi bi-cash-coin",
              value: "totalCheckSale",
              color: "text-warning",
            },
          ],
        },
        {
          key: "purchases",
          items: [
            {
              label: "Total Achats d'aujourd'hui",
              icon: "bi bi-cart3",
              value: "priceTotalTTCPurchase",
              color: "text-primary",
            },
            {
              label: "Total Achats Payé",
              icon: "bi bi-window-x",
              value: "totalPaidPurchase",
              color: "text-success",
            },
            {
              label: "Total Achats Impayé",
              icon: "bi bi-window-dash",
              value: "totalUnpaidPurchase",
              color: "text-danger",
            },
            {
              label: "Règlement Achats Impayé",
              icon: "bi bi-cash-stack",
              value: "totalPaidOldBillPurchase",
              color: "text-warning",
            },
            {
              label: "Achats Payé Espèces",
              icon: "bi bi-cash",
              value: "totalCashPurchase",
              color: "text-success",
            },
            {
              label: "Achats Payé Virements",
              icon: "bi bi-bank",
              value: "totalBankTransferPurchase",
              color: "text-danger",
            },
            {
              label: "Achats Payé Chèques",
              icon: "bi bi-cash-coin",
              value: "totalCheckPurchase",
              color: "text-warning",
            },
          ],
        },
        {
          key: "expenses",
          items: [
            {
              label: "Total Dépenses Aujourd'hui",
              icon: "bi bi-cart3",
              value: "priceTotalTTCExpense",
              color: "text-primary",
            },
            {
              label: "Dépenses Payé Espèces",
              icon: "bi bi-cash",
              value: "totalCashExpense",
              color: "text-success",
            },
            {
              label: "Dépenses Payé Virements",
              icon: "bi bi-bank",
              value: "totalBankTransferExpense",
              color: "text-danger",
            },
            {
              label: "Dépenses Payé Chèques",
              icon: "bi bi-cash-coin",
              value: "totalCheckExpense",
              color: "text-warning",
            },
          ],
        },
        {
          key: "transactions",
          items: [
            {
              label: "Total Transactions Aujourd'hui",
              icon: "bi bi-receipt",
              value: "priceTotalTTCTransaction",
              color: "text-primary",
            },
            {
              label: "Transactions Payé Espèces",
              icon: "bi bi-cash",
              value: "totalCashTransaction",
              color: "text-success",
            },
            {
              label: "Transactions Payé Virements",
              icon: "bi bi-bank",
              value: "totalBankTransferTransaction",
              color: "text-danger",
            },
            {
              label: "Transactions Payé Chèques",
              icon: "bi bi-cash-coin",
              value: "totalCheckTransaction",
              color: "text-warning",
            },
          ],
        },
      ],
      filter: {
        startDate: "",
        endDate: "",
      },
      sellerStatsFilter: {
        startDate: today,
        endDate: today,
        seller_reference: "",
      },
      sellerStatsLoading: false,
    };
  },
  computed: {
    ...mapGetters("statistic", {
      totalTodays: "getTotalTodays",
      // barTodaysChartData: "getBarTodaysChartData",
      quantityAnalytics: "getQuantityAnalytics",
      deliveries: "getDeliveries",
      sellersStatistics: "getSellersStatistics",
    }),

    ...mapGetters("user", {
      users: "getAll",
      userOnline: "getUserOnline",
    }),
    ...mapGetters("seller", {
      sellersList: "getAll",
    }),
    ...mapGetters("credit", {
      credits: "getCredits",
    }),
    ...mapGetters("invoice", {
      invoices: "getInvoices",
    }),

    ...mapGetters("check", {
      checks: "getChecks",
    }),
    ...mapGetters("customer", {
      customers: "getAll",
    }),

    soldeEnCaisse() {
      const soldeData =
        this.totalTodays && this.totalTodays.soldeEnCaisse
          ? this.totalTodays.soldeEnCaisse
          : {};

      // If backend provides the calculated solde, use it
      if (soldeData.solde !== undefined) {
        return parseFloat(soldeData.solde || 0) || 0;
      }

      // Otherwise calculate: Total cash payments (all time) - Total cash transactions (all time) - Total cash expenses (all time)
      const totalCashPayments = parseFloat(soldeData.totalCashPaymentsAll || 0) || 0;
      const totalCashTransactions = parseFloat(soldeData.totalCashTransactionsAll || 0) || 0;
      const totalCashExpenses = parseFloat(soldeData.totalCashExpensesAll || 0) || 0;

      return totalCashPayments - totalCashTransactions - totalCashExpenses;
    },

    caisseHier() {
      const soldeData =
        this.totalTodays && this.totalTodays.soldeEnCaisse
          ? this.totalTodays.soldeEnCaisse
          : {};

      return parseFloat(soldeData.caisseHier || 0) || 0;
    },

    reglementToday() {
      const soldeData =
        this.totalTodays && this.totalTodays.soldeEnCaisse
          ? this.totalTodays.soldeEnCaisse
          : {};

      return parseFloat(soldeData.reglementToday || 0) || 0;
    },

    pieChartData() {
      const paymentCounts = {
        Espèce: 0,
        Chèque: 0,
        "Virement bancaire": 0,
        Impayé: 0,
      };

      this.invoices.forEach((inv) => {
        const amountPaid = parseFloat(inv.amountPaid) || 0;
        const totalPrice = parseFloat(inv.totalPriceTTC) || 0;
        let method = inv.paymentMethod;

        if (amountPaid > 0) {
          if (method && paymentCounts[method] !== undefined) {
            paymentCounts[method] += amountPaid;
          } else {
            paymentCounts["Impayé"] += amountPaid;
          }
        } else {
          paymentCounts["Impayé"] += totalPrice;
        }
      });

      return {
        labels: Object.keys(paymentCounts),
        datasets: [
          {
            backgroundColor: ["#4CAF50", "#FFC107", "#03A9F4", "#F44336"],
            data: Object.values(paymentCounts),
          },
        ],
      };
    },

    pieChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "bottom",
          },
        },
      };
    },

    lineChartData() {
      const today = new Date();
      const startDate = new Date();
      startDate.setDate(today.getDate() - 19); // 20 jours en tout

      const totals = {};
      for (let i = 0; i < 20; i++) {
        const date = new Date(startDate);
        date.setDate(startDate.getDate() + i);
        const formatted = date.toISOString().split("T")[0];
        totals[formatted] = {
          total: 0,
          paid: 0,
          unpaid: 0,
        };
      }

      this.invoices.forEach((inv) => {
        const invoiceDate = new Date(inv.date || inv.saleDate);
        const formatted = invoiceDate.toISOString().split("T")[0];
        if (totals[formatted]) {
          totals[formatted].total += parseFloat(inv.totalPriceTTC) || 0;
          totals[formatted].paid += parseFloat(inv.amountPaid) || 0;
          totals[formatted].unpaid += parseFloat(inv.amountUnpaid) || 0;
        }
      });

      return {
        labels: Object.keys(totals),
        datasets: [
          {
            label: this.$t("Total TTC"),
            backgroundColor: "#42A5F5",
            borderColor: "#42A5F5",
            fill: false,
            tension: 0.3,
            data: Object.values(totals).map((item) => parseFloat(item.total)),
          },
          {
            label: this.$t("Montant payé"),
            backgroundColor: "#66BB6A",
            borderColor: "#66BB6A",
            fill: false,
            tension: 0.3,
            data: Object.values(totals).map((item) => parseFloat(item.paid)),
          },
          {
            label: this.$t("Montant impayé"),
            backgroundColor: "#EF5350",
            borderColor: "#EF5350",
            fill: false,
            tension: 0.3,
            data: Object.values(totals).map((item) => parseFloat(item.unpaid)),
          },
        ],
      };
    },

    lineChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: "bottom",
          },
        },
        scales: {
          x: {
            ticks: {
              maxRotation: 90,
              minRotation: 45,
            },
          },
          y: {
            beginAtZero: true,
          },
        },
      };
    },
    sellerStatisticsTotals() {
      if (!this.sellersStatistics || !this.sellersStatistics.length) {
        return {
          totalCustomers: 0,
          totalSalesPrice: 0,
          totalSalesPaid: 0,
          totalSalesUnpaid: 0,
          totalPriceToday: 0,
          amountPaidToday: 0,
          totalPriceMonth: 0,
          amountPaidMonth: 0,
          receivedFromCustomers: 0,
        };
      }

      return this.sellersStatistics.reduce(
        (acc, seller) => {
          acc.totalCustomers += Number(seller.totalCustomers) || 0;
          acc.totalSalesPrice += Number(seller.salesTotalPrice) || 0;
          acc.totalSalesPaid += Number(seller.salesTotalPaid) || 0;
          acc.totalSalesUnpaid += Number(seller.salesTotalUnpaid) || 0;
          acc.totalPriceToday += Number(seller.totalPriceToday) || 0;
          acc.amountPaidToday += Number(seller.amountPaidToday) || 0;
          acc.totalPriceMonth += Number(seller.totalPriceMonth) || 0;
          acc.amountPaidMonth += Number(seller.amountPaidMonth) || 0;
          acc.receivedFromCustomers +=
            Number(seller.receivedFromCustomers) || 0;
          return acc;
        },
        {
          totalCustomers: 0,
          totalSalesPrice: 0,
          totalSalesPaid: 0,
          totalSalesUnpaid: 0,
          totalPriceToday: 0,
          amountPaidToday: 0,
          totalPriceMonth: 0,
          amountPaidMonth: 0,
          receivedFromCustomers: 0,
        }
      );
    },
    sellerStatisticSummaryCards() {
      const totals = this.sellerStatisticsTotals;
      return [
        {
          label: "Clients suivis",
          icon: "bi bi-people",
          color: "primary",
          value: this.formatInteger(totals.totalCustomers),
        },
        {
          label: "Total ventes TTC",
          icon: "bi bi-cart-check",
          color: "primary",
          value: this.formatAmount(totals.totalSalesPrice),
        },
        {
          label: "Montant perçu",
          icon: "bi bi-currency-dollar",
          color: "primary",
          value: this.formatAmount(totals.receivedFromCustomers),
        },
        {
          label: "Montant impayé",
          icon: "bi bi-exclamation-circle",
          color: "primary",
          value: this.formatAmount(totals.totalSalesUnpaid),
        },
      ];
    },

    soldQuantityChartData() {
      const soldCounts = {};

      this.quantityAnalytics.forEach((item) => {
        const label = item.fullName || "Inconnu";
        const quantity = item.soldQuantity || 0;

        if (label.toUpperCase().includes("MANUTENTION")) {
          return; // Exclure les entrées contenant "MANUTENTION"
        }

        if (!soldCounts[label]) {
          soldCounts[label] = 0;
        }

        soldCounts[label] += quantity;
      });

      return {
        labels: Object.keys(soldCounts),
        datasets: [
          {
            backgroundColor: [
              "#4CAF50",
              "#FFC107",
              "#03A9F4",
              "#F44336",
              "#9C27B0",
              "#009688",
              "#E91E63",
              "#00BCD4",
            ],
            data: Object.values(soldCounts),
          },
        ],
      };
    },

    soldQuantityChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "bottom",
          },
        },
      };
    },

    top10Credits() {
      if (!this.credits) return [];
      var sortedCredits = this.credits.sort(
        (a, b) => b.totalUnpaid - a.totalUnpaid
      );
      return sortedCredits.slice(0, 10);
    },
    top10TotalUnpaidSum() {
      if (!this.top10Credits) return 0;
      return this.top10Credits.reduce(
        (acc, credit) => acc + credit.totalUnpaid,
        0
      );
    },

    filteredChecks() {
      const today = new Date().toISOString().split("T")[0];

      return this.checks.filter((check) => {
        const deadline = check.deadline ? check.deadline.split("T")[0] : null;
        return deadline && deadline <= today && check.inTransaction === false;
      });
    },
    topSellers() {
      if (!this.sellersStatistics || !this.sellersStatistics.length) {
        return [];
      }
      return [...this.sellersStatistics]
        .sort(
          (a, b) =>
            (parseFloat(b.salesTotalPrice) || 0) -
            (parseFloat(a.salesTotalPrice) || 0)
        )
        .slice(0, 10);
    },
    // ── helpers ──
    s() { return (this.totalTodays && this.totalTodays.sales)       || {}; },
    p() { return (this.totalTodays && this.totalTodays.payments)    || {}; },
    pu(){ return (this.totalTodays && this.totalTodays.purchases)   || {}; },
    ex(){ return (this.totalTodays && this.totalTodays.expenses)    || {}; },
    tr(){ return (this.totalTodays && this.totalTodays.transactions)|| {}; },
    ch(){ return (this.totalTodays && this.totalTodays.checks)      || {}; },
    or(){ return (this.totalTodays && this.totalTodays.orders)      || {}; },
    calculationError() {
      return (
        (this.totalTodays && this.totalTodays.calculationErrors) || {}
      );
    },
    hasCalculationErrors() {
      const error = this.calculationError;
      const hasFlag =
        error.hasErrors === true ||
        error.hasErrors === 1 ||
        error.hasErrors === "1" ||
        error.hasErrors === "true";

      return (
        hasFlag ||
        this.calculationErrorCustomers.length > 0 ||
        this.hasAmountDelta(error.paymentVsSalesPaidDifference) ||
        this.hasAmountDelta(error.allocatedVsSalesPaidDifference) ||
        this.hasAmountDelta(error.paymentsVsLinksDifference) ||
        this.hasAmountDelta(error.linksVsSalesPaidDifference) ||
        Number(error.orphanPaymentsCount || 0) > 0 ||
        Number(error.salesWithPaymentMismatchCount || 0) > 0
      );
    },
    calculationErrorCustomers() {
      return Array.isArray(this.calculationError.customers)
        ? this.calculationError.customers
        : [];
    },
    calculationErrorRows() {
      return [
        {
          label: "Total paiements clients",
          value: this.calculationError.paymentTotal || 0,
        },
        {
          label: "Reste non affecte",
          value: this.calculationError.paymentRemainingTotal || 0,
        },
        {
          label: "Paiements affectes",
          value: this.calculationError.allocatedPaymentTotal || 0,
        },
        {
          label: "Liens paiement-vente",
          value: this.calculationError.paymentSaleLinkTotal || 0,
        },
        {
          label: "Ventes payees",
          value: this.calculationError.saleAmountPaidTotal || 0,
        },
        {
          label: "Ecart paiements-ventes",
          value: this.calculationError.paymentVsSalesPaidDifference || 0,
          danger: true,
        },
        {
          label: "Ecart affecte-ventes",
          value: this.calculationError.allocatedVsSalesPaidDifference || 0,
          danger: true,
        },
        {
          label: "Ecart affecte-liens",
          value: this.calculationError.paymentsVsLinksDifference || 0,
          danger: true,
        },
        {
          label: "Ecart liens-ventes",
          value: this.calculationError.linksVsSalesPaidDifference || 0,
          danger: true,
        },
      ];
    },

    totalImpayeClients() {
      if (!this.credits) return 0;
      return this.credits.reduce((acc, c) => acc + parseFloat(c.totalUnpaid || 0), 0);
    },
    blockedCustomersCount() {
      if (!this.customers) return 0;
      return this.customers.filter(c => c.blocked == 1 || c.blocked === true).length;
    },
    top10Items() {
      if (!this.quantityAnalytics) return [];
      return [...this.quantityAnalytics]
        .filter(i => !String(i.fullName || '').toUpperCase().includes('MANUTENTION'))
        .sort((a, b) => b.soldQuantity - a.soldQuantity)
        .slice(0, 10);
    },

    kpiCards() {
      return [
        { label: "CA aujourd'hui",    icon: "bi bi-cart3",          hex: "#0d6efd", value: parseFloat(this.s.priceTotalTTCSale    || 0) },
        { label: "Payé aujourd'hui",  icon: "bi bi-check-circle",   hex: "#198754", value: parseFloat(this.s.totalPaidSale        || 0) },
        { label: "Impayé du jour",    icon: "bi bi-exclamation-lg", hex: "#dc3545", value: parseFloat(this.s.totalUnpaidSale      || 0) },
        { label: "Achats du jour",    icon: "bi bi-box-arrow-in-down", hex: "#6610f2", value: parseFloat(this.pu.priceTotalTTCPurchase || 0) },
        { label: "Dépenses du jour",  icon: "bi bi-wallet2",        hex: "#fd7e14", value: parseFloat(this.ex.priceTotalTTCExpense || 0) },
        { label: "Règlement impayés", icon: "bi bi-cash-stack",     hex: "#0dcaf0", value: parseFloat(this.p.totalPaidOldBillSale  || 0) },
      ];
    },
    orderDayCards() {
      return [
        { icon: "bi bi-cart3",          color: "primary", title: "Commandes du jour",          value: this.or.totalOrders              || 0 },
        { icon: "bi bi-hourglass-split", color: "warning", title: "En attente livraison",       value: this.or.pendingDeliveryOrders    || 0 },
        { icon: "bi bi-clock-history",   color: "danger",  title: "En attente validation",      value: this.or.pendingValidationOrders  || 0 },
        { icon: "bi bi-check2-all",      color: "success", title: "Commandes validées (total)", value: this.or.completedOrdersAll       || 0 },
      ];
    },
    alertCards() {
      const checksTotal = parseFloat(this.ch.totalUnpaidCustomerChecks || 0);
      const checksSupplier = parseFloat(this.ch.totalUnpaidSupplierChecks || 0);
      return [
        { icon: "bi bi-people-fill",       type: "danger",  label: "Total impayé clients",         value: this.totalImpayeClients },
        { icon: "bi bi-bank",              type: "warning", label: "Chèques clients en attente",   value: checksTotal },
        { icon: "bi bi-building",          type: "warning", label: "Chèques fournisseurs en att.", value: checksSupplier },
        { icon: "bi bi-calendar-x",        type: "danger",  label: "Chèques échus aujourd'hui",    value: this.filteredChecks.length },
        { icon: "bi bi-person-x",          type: "secondary", label: "Clients bloqués",            value: this.blockedCustomersCount },
        { icon: "bi bi-file-earmark-check",type: "info",    label: "Factures (20 derniers jours)", value: this.invoices.length },
        { icon: "bi bi-bag-check",         type: "success", label: "Encaissement espèces — mois", value: parseFloat(this.p.totalCashSaleMonth || 0) },
        { icon: "bi bi-receipt",           type: "primary", label: "Règlements impayés — mois",   value: parseFloat(this.p.totalPaidOldBillSaleMonth || 0) },
      ];
    },
    paymentMethodsMonth() {
      const cash  = parseFloat(this.p.totalCashSaleMonth          || 0);
      const vir   = parseFloat(this.p.totalBankTransferSaleMonth  || 0);
      const chq   = parseFloat(this.p.totalCheckSaleMonth         || 0);
      const total = cash + vir + chq || 1;
      return [
        { label: "Espèces",           icon: "bi bi-cash",         color: "#198754", value: cash, pct: (cash  / total * 100).toFixed(1) },
        { label: "Virement bancaire", icon: "bi bi-bank",         color: "#0d6efd", value: vir,  pct: (vir   / total * 100).toFixed(1) },
        { label: "Chèque",            icon: "bi bi-cash-coin",    color: "#fd7e14", value: chq,  pct: (chq   / total * 100).toFixed(1) },
      ];
    },
    dailyFinancialRows() {
      return [
        { icon: "bi bi-cart3",             label: "Ventes TTC",           color: "text-primary", value: parseFloat(this.s.priceTotalTTCSale           || 0) },
        { icon: "bi bi-check-circle",      label: "Dont payé",            color: "text-success", value: parseFloat(this.s.totalPaidSale               || 0) },
        { icon: "bi bi-exclamation-circle",label: "Dont impayé",          color: "text-danger",  value: parseFloat(this.s.totalUnpaidSale             || 0) },
        { icon: "bi bi-cash",              label: "Payé en espèces",      color: "text-success", value: parseFloat(this.p.totalCashSale               || 0) },
        { icon: "bi bi-bank",              label: "Payé en virement",     color: "text-primary", value: parseFloat(this.p.totalBankTransferSale       || 0) },
        { icon: "bi bi-cash-coin",         label: "Payé en chèque",       color: "text-warning", value: parseFloat(this.p.totalCheckSale              || 0) },
        { icon: "bi bi-box-arrow-in-down", label: "Achats",               color: "text-purple",  value: parseFloat(this.pu.priceTotalTTCPurchase      || 0) },
        { icon: "bi bi-wallet2",           label: "Dépenses",             color: "text-danger",  value: parseFloat(this.ex.priceTotalTTCExpense       || 0) },
        { icon: "bi bi-arrow-left-right",  label: "Transactions",         color: "text-info",    value: parseFloat(this.tr.priceTotalTTCTransaction   || 0) },
        { icon: "bi bi-wallet-fill",       label: "Solde en caisse",      color: "text-success", value: this.soldeEnCaisse },
      ];
    },

    orderCards() {
      const orders =
        this.totalTodays && this.totalTodays.orders
          ? this.totalTodays.orders
          : {};
      return [
        //     {
        //       icon: "bi bi-cart3",
        //       color: "primary",
        //       title: "Commandes du jour",
        //       value: orders ? orders.totalOrders : 0,
        //     },
        //     {
        //       icon: "bi bi-window-x",
        //       color: "warning",
        //       title: "En attente de livraison",
        //       value: orders ? orders.pendingDeliveryOrders : 0,
        //     },
        //     {
        //       icon: "bi bi-window-dash",
        //       color: "danger",
        //       title: "En attente de validation",
        //       value: orders ? orders.pendingValidationOrders : 0,
        //     },
        //     {
        //       icon: "bi bi-cash-stack",
        //       color: "success",
        //       title: "Commandes validées",
        //       value: orders ? orders.completedOrders : 0,
        //     },
      ];
    },

    totalOrderCards() {
      const orders =
        this.totalTodays && this.totalTodays.orders
          ? this.totalTodays.orders
          : {};
      return [
        //     {
        //       icon: "bi bi-cart3",
        //       color: "primary",
        //       title: "Total commandes",
        //       value: orders ? orders.totalOrdersAll : 0,
        //     },
        //     {
        //       icon: "bi bi-window-x",
        //       color: "warning",
        //       title: "Total en attente de livraison",
        //       value: orders ? orders.pendingDeliveryOrdersAll : 0,
        //     },
        //     {
        //       icon: "bi bi-window-dash",
        //       color: "danger",
        //       title: "Total en attente de validation",
        //       value: orders ? orders.pendingValidationOrdersAll : 0,
        //     },
        //     {
        //       icon: "bi bi-cash-stack",
        //       color: "success",
        //       title: "Total commandes validées",
        //       value: orders ? orders.completedOrdersAll : 0,
        //     },
      ];
    },

    paymentCards() {
      const payments =
        this.totalTodays && this.totalTodays.payments
          ? this.totalTodays.payments
          : {};
      const transactions =
        this.totalTodays && this.totalTodays.transactions
          ? this.totalTodays.transactions
          : {};
      const expenses =
        this.totalTodays && this.totalTodays.expenses
          ? this.totalTodays.expenses
          : {};

      // Get sales data
      const sales =
        this.totalTodays && this.totalTodays.sales
          ? this.totalTodays.sales
          : {};

      // Calculate solde en caisse
      // Formula: (Total paid sales today + Old bill payments) - Cash transactions - Cash expenses
      // Only cash payments count for cash balance, but we include all old bill payments
      const totalPaidSale = parseFloat(sales.totalPaidSale || 0) || 0;
      const totalPaidOldBillSale = parseFloat(payments.totalPaidOldBillSale || 0) || 0;
      const totalCashTransaction = parseFloat(transactions.totalCashTransaction || 0) || 0;
      const totalCashExpense = parseFloat(expenses.totalCashExpense || 0) || 0;

      return [
        // {
        //   icon: "bi bi-receipt",
        //   color: "primary",
        //   title: "Factures réglées du jour",
        //   value: payments ? payments.totalPaidOldBillSale : 0,
        // },
        // {
        //   icon: "bi bi-cash-coin",
        //   color: "warning",
        //   title: "Ventes en espèces du jour",
        //   value: payments ? payments.totalCashSale : 0,
        // },
        // {
        //   icon: "bi bi-credit-card",
        //   color: "danger",
        //   title: "Ventes par virement du jour",
        //   value: payments ? payments.totalBankTransferSale : 0,
        // },
        // {
        //   icon: "bi bi-bank",
        //   color: "success",
        //   title: "Ventes par chèque du jour",
        //   value: payments ? payments.totalCheckSale : 0,
        // },
        // {
        //   icon: "bi bi-calendar-check",
        //   color: "info",
        //   title: "Factures réglées du mois",
        //   value: payments ? payments.totalPaidOldBillSaleMonth : 0,
        // },
        // {
        //   icon: "bi bi-cash",
        //   color: "secondary",
        //   title: "Ventes en espèces du mois",
        //   value: payments ? payments.totalCashSaleMonth : 0,
        // },
        // {
        //   icon: "bi bi-credit-card",
        //   color: "dark",
        //   title: "Ventes par virement du mois",
        //   value: payments ? payments.totalBankTransferSaleMonth : 0,
        // },
        // {
        //   icon: "bi bi-bank",
        //   color: "primary",
        //   title: "Ventes par chèque du mois",
        //   value: payments ? payments.totalCheckSaleMonth : 0,
        // },
      ];
    },
  },
  async mounted() {
    await this.$store.dispatch("statistic/fetchTotalTodays");
    await this.$store.dispatch("statistic/fetchDeliveries");
    await this.$store.dispatch(
      "statistic/fetchQuantityAnalytics",
      moment(new Date()).format("YYYY-MM-DD")
    );
    await this.$store.dispatch("seller/getAll");
    await this.fetchSellerStatistics();
    await this.$store.dispatch("user/getAll");
    await this.$store.dispatch("user/fetchUserStatus");
    await this.$store.dispatch("credit/getAll");
    await this.$store.dispatch("invoice/getAll");
    await this.$store.dispatch("check/getAll");
    await this.$store.dispatch("customer/getAll");
    await this.$store.dispatch("sellerCustomer/getAll");
  },
  methods: {
    hasAmountDelta(value) {
      const amount = Number.parseFloat(value || 0);
      return !Number.isNaN(amount) && Math.abs(amount) > 0.01;
    },
    getCustomerCalculationIssues(customer) {
      const issues = [];

      if (this.hasAmountDelta(customer.paymentVsSalesPaidDifference)) {
        issues.push("Paiements != ventes");
      }
      if (this.hasAmountDelta(customer.allocatedVsSalesPaidDifference)) {
        issues.push("Affecte != ventes");
      }
      if (this.hasAmountDelta(customer.paymentsVsLinksDifference)) {
        issues.push("Affecte != liens");
      }
      if (this.hasAmountDelta(customer.linksVsSalesPaidDifference)) {
        issues.push("Liens != ventes");
      }
      if (Number(customer.orphanPaymentsCount || 0) > 0) {
        issues.push("Sans facture");
      }
      if (Number(customer.salesWithPaymentMismatchCount || 0) > 0) {
        issues.push("Vente incoherente");
      }

      return issues.length ? issues : ["Ecart"];
    },
    async refresh() {
      await this.$store.dispatch("statistic/fetchTotalTodays");
      await this.$store.dispatch("statistic/fetchDeliveries");
      await this.$store.dispatch(
        "statistic/fetchQuantityAnalytics",
        moment(new Date()).format("YYYY-MM-DD")
      );
      await this.fetchSellerStatistics();
      await this.$store.dispatch("seller/getAll");
      await this.$store.dispatch("user/getAll");
      await this.$store.dispatch("user/fetchUserStatus");
      await this.$store.dispatch("credit/getAll");
      await this.$store.dispatch("invoice/getAll");
      await this.$store.dispatch("check/getAll");
      await this.$store.dispatch("customer/getAll");
      await this.$store.dispatch("sellerCustomer/getAll");
    },
    async filterQuantityData(filter) {
      await this.$store.dispatch("statistic/fetchQuantityAnalytics", filter);
    },
    async fetchSellerStatistics(filterOverrides = null) {
      this.sellerStatsLoading = true;
      try {
        const payload = this.sanitizeSellerStatsPayload(
          filterOverrides || this.sellerStatsFilter
        );
        await this.$store.dispatch("statistic/fetchSellersStatistics", payload);
      } finally {
        this.sellerStatsLoading = false;
      }
    },
    sanitizeSellerStatsPayload(filter) {
      if (!filter) {
        return {};
      }
      return Object.entries(filter).reduce((acc, [key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {});
    },
    async applySellerStatsFilter() {
      await this.fetchSellerStatistics();
    },
    async resetSellerStatsFilter() {
      this.sellerStatsFilter = this.getDefaultSellerStatsFilter();
      await this.fetchSellerStatistics();
    },
    getDefaultSellerStatsFilter() {
      const today = moment(new Date()).format("YYYY-MM-DD");
      return {
        startDate: today,
        endDate: today,
        seller_reference: "",
      };
    },
    formatInteger(value) {
      const number = Number(value || 0);
      return Number.isNaN(number)
        ? "-"
        : new Intl.NumberFormat("fr-FR").format(number);
    },
    formatQuantity(value) {
      const number = Number.parseFloat(value || 0);
      return Number.isNaN(number)
        ? "-"
        : new Intl.NumberFormat("fr-FR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(number);
    },
    formatAmount(value) {
      const number = Number.parseFloat(value || 0);
      return Number.isNaN(number)
        ? "-"
        : new Intl.NumberFormat("fr-FR", {
            style: "currency",
            currency: "MAD",
            minimumFractionDigits: 2,
          }).format(number);
    },
  },
  filters: {
    formatWithSpaces(value) {
      // Ensure the value is a number and fix it to 2 decimal places
      const fixedValue = Number(value).toFixed(2);
      // Convert the fixed number to a string and apply spaces as thousands separators
      return fixedValue.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
};
</script>

<style scoped>
.dashboard-card {
  background: #fff !important;
  border-radius: 12px !important;
  padding: 1.2rem !important;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid #f1f1f1 !important;
  transition: all 0.3s ease-in-out !important;
}
.dashboard-card:hover {
  transform: translateY(-3px) !important;
  box-shadow: 0 6px 16px rgba(4, 108, 193, 0.15) !important;
}
.icon-wrapper {
  width: 52px !important;
  height: 52px !important;
  border-radius: 50% !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px !important;
}
.bg-primary-light {
  background-color: rgba(4, 108, 193, 0.12) !important;
}
.bg-success-light {
  background-color: rgba(25, 135, 84, 0.12) !important;
}
.bg-danger-light {
  background-color: rgba(220, 53, 69, 0.12) !important;
}
.bg-warning-light {
  background-color: rgba(255, 193, 7, 0.15) !important;
}
.bg-info-light {
  background-color: rgba(13, 202, 240, 0.15) !important;
}
.bg-secondary-light {
  background-color: rgba(108, 117, 125, 0.15) !important;
}
.bg-dark-light {
  background-color: rgba(33, 37, 41, 0.15) !important;
}
.info h6 {
  margin: 0;
  font-size: 14px !important;
  color: #6c757d !important;
}
.info h4 {
  margin: 0;
  font-weight: 700 !important;
  font-size: 20px !important;
}

.card {
  border-radius: 1rem !important;
  background-color: #fff !important;
  transition: all 0.3s ease-in-out !important;
}

.card:hover {
  box-shadow: 0 6px 16px rgba(4, 108, 193, 0.15) !important;
}

.modern-table thead th {
  font-size: 0.9rem;
  letter-spacing: 0.4px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.05);
}

.modern-table tbody td {
  font-size: 0.95rem;
  border-top: 1px solid rgba(0, 0, 0, 0.04);
  vertical-align: middle !important;
  transition: background-color 0.2s ease;
}

.hover-row:hover {
  background-color: rgba(4, 108, 193, 0.05) !important;
}

tfoot td {
  border-top: 2px solid rgba(0, 0, 0, 0.08) !important;
}

.badge {
  font-weight: 600 !important;
  border-radius: 0.5rem !important;
}

.dashboard-totals {
  background: #f9fafb;
}

.section-card {
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(6px);
}

.section-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}

.hover-bg:hover {
  background-color: #f3f4f6;
}

/* Professional Blue-Themed Seller Statistics Styles */
.seller-stats-container {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(4, 108, 193, 0.08);
  overflow: hidden;
  margin-bottom: 2rem;
}

.seller-stats-header {
  background: linear-gradient(135deg, #046cc1 0%, #1588d9 100%);
  padding: 1.5rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
  flex-wrap: wrap;
  gap: 1rem;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.header-icon {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
}

.header-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
  color: white;
}

.header-subtitle {
  font-size: 0.875rem;
  margin: 0.25rem 0 0 0;
  color: rgba(255, 255, 255, 0.9);
}

.header-badge {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 0.75rem 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}

.badge-count {
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  line-height: 1;
}

.badge-text {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.9);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.seller-stats-body {
  padding: 2rem;
}

.seller-stats-filters {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: #f8fafb;
  border-radius: 12px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.filter-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #046cc1;
  margin: 0;
}

.filter-input,
.filter-select {
  padding: 0.625rem 1rem;
  border: 2px solid #e0ecf5;
  border-radius: 8px;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  background: white;
}

.filter-input:focus,
.filter-select:focus {
  outline: none;
  border-color: #046cc1;
  box-shadow: 0 0 0 3px rgba(4, 108, 193, 0.1);
}

.filter-actions {
  display: flex;
  gap: 0.75rem;
  align-items: flex-end;
}

.btn-filter {
  padding: 0.625rem 1.25rem;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-filter.btn-primary {
  background: #046cc1;
  color: white;
  box-shadow: 0 2px 8px rgba(4, 108, 193, 0.2);
}

.btn-filter.btn-primary:hover:not(:disabled) {
  background: #035ca5;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(4, 108, 193, 0.3);
}

.btn-filter.btn-outline {
  background: white;
  color: #046cc1;
  border: 2px solid #046cc1;
}

.btn-filter.btn-outline:hover:not(:disabled) {
  background: #f0f7ff;
  transform: translateY(-2px);
}

.btn-filter:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.summary-card {
  background: linear-gradient(135deg, #f0f7ff 0%, #ffffff 100%);
  border: 2px solid #e0ecf5;
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: all 0.3s ease;
}

.summary-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(4, 108, 193, 0.15);
  border-color: #046cc1;
}

.summary-icon {
  width: 56px;
  height: 56px;
  background: #046cc1;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
  flex-shrink: 0;
}

.summary-content {
  flex: 1;
}

.summary-label {
  font-size: 0.75rem;
  color: #6b7280;
  font-weight: 500;
  margin: 0 0 0.5rem 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.summary-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #046cc1;
  margin: 0;
}

.loading-state {
  padding: 4rem 2rem;
  text-align: center;
}

.loading-text {
  margin-top: 1rem;
  color: #6b7280;
  font-size: 0.875rem;
}

.empty-state {
  padding: 4rem 2rem;
  text-align: center;
  color: #9ca3af;
}

.empty-state i {
  font-size: 3rem;
  margin-bottom: 1rem;
  display: block;
}

.calculation-error-banner {
  background: #fff5f5;
  border: 1px solid #f1aeb5;
  border-left: 5px solid #dc3545;
  border-radius: 8px;
  padding: 1rem;
  color: #842029;
}

.calculation-error-header {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
}

.calculation-error-header i {
  font-size: 1.6rem;
  line-height: 1;
}

.calculation-error-header h6 {
  font-weight: 700;
  margin: 0 0 0.25rem;
}

.calculation-error-header p {
  margin: 0;
  color: #842029;
}

.calculation-error-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 0.5rem;
}

.calculation-error-metric {
  background: #fff;
  border: 1px solid #f8d7da;
  border-radius: 8px;
  padding: 0.65rem 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.calculation-error-metric span {
  color: #6c757d;
  font-size: 0.75rem;
  text-transform: uppercase;
}

.calculation-error-metric strong {
  color: #212529;
  font-size: 1rem;
}

.calculation-error-metric.danger strong {
  color: #dc3545;
}

.calculation-error-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 0.75rem;
  font-size: 0.9rem;
}

.calculation-error-customers {
  background: #fff;
  border: 1px solid #f8d7da;
  border-radius: 8px;
  margin-top: 0.9rem;
  overflow: hidden;
}

.calculation-error-table-title {
  background: #f8d7da;
  color: #842029;
  font-weight: 600;
  padding: 0.6rem 0.75rem;
}

.calculation-error-customers .table {
  color: #212529;
}

.calculation-error-customer-link {
  color: #842029;
  display: inline-block;
  text-decoration: none;
}

.calculation-error-customer-link:hover {
  color: #6f1d1b;
  text-decoration: underline;
}

.calculation-error-issues {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  min-width: 190px;
}

.calculation-error-issue {
  background: #fff5f5;
  border: 1px solid #f1aeb5;
  border-radius: 8px;
  color: #842029;
  font-size: 0.72rem;
  font-weight: 600;
  line-height: 1;
  padding: 0.25rem 0.45rem;
  white-space: nowrap;
}

.calculation-error-customers th {
  color: #6c757d;
  font-size: 0.75rem;
  text-transform: uppercase;
  white-space: nowrap;
}

.calculation-error-customers td {
  vertical-align: middle;
  white-space: nowrap;
}

.calculation-error-customers small {
  color: #6c757d;
}

.seller-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem;
}

.seller-card-pro {
  background: white;
  border: 2px solid #e0ecf5;
  border-radius: 16px;
  padding: 1.5rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(4, 108, 193, 0.05);
}

.seller-card-pro:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(4, 108, 193, 0.15);
  border-color: #046cc1;
}

.seller-card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #f0f7ff;
}

.seller-rank-badge {
  width: 48px;
  height: 48px;
  background: #046cc1;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.rank-number {
  font-size: 1.125rem;
  font-weight: 700;
  color: white;
}

.seller-info {
  flex: 1;
}

.seller-name {
  font-size: 1rem;
  font-weight: 700;
  color: #046cc1;
  margin: 0 0 0.25rem 0;
}

.seller-reference {
  font-size: 0.75rem;
  color: #9ca3af;
  margin: 0;
  font-weight: 500;
}

.seller-stats-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.stat-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.stat-row-full {
  grid-template-columns: 1fr;
}

.stat-box {
  background: #f0f7ff;
  border: 1px solid #e0ecf5;
  border-radius: 10px;
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  transition: all 0.3s ease;
}

.stat-box:hover {
  background: #e0ecf5;
  border-color: #046cc1;
  transform: translateY(-2px);
}

.stat-box-highlight {
  background: linear-gradient(135deg, #e0ecf5 0%, #f0f7ff 100%);
  border: 2px solid #046cc1;
}

.stat-icon {
  width: 40px;
  height: 40px;
  background: #046cc1;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.125rem;
  color: white;
  flex-shrink: 0;
}

.stat-icon-highlight {
  width: 48px;
  height: 48px;
  font-size: 1.25rem;
  background: #046cc1;
}

.stat-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.stat-label {
  font-size: 0.75rem;
  color: #6b7280;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-value {
  font-size: 1rem;
  font-weight: 700;
  color: #046cc1;
}

.stat-value-highlight {
  font-size: 1.25rem;
  color: #046cc1;
}

@media (max-width: 768px) {
  .seller-stats-filters {
    grid-template-columns: 1fr;
  }

  .filter-actions {
    flex-direction: column;
  }

  .btn-filter {
    width: 100%;
  }

  .summary-cards {
    grid-template-columns: 1fr;
  }

  .seller-cards-grid {
    grid-template-columns: 1fr;
  }

  .stat-row {
    grid-template-columns: 1fr;
  }
}

.skeleton {
  width: 80px;
  height: 14px;
  border-radius: 6px;
  background: linear-gradient(90deg, #eee 25%, #f5f5f5 37%, #eee 63%);
  background-size: 400% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0%   { background-position: 100% 0; }
  100% { background-position: 0 0; }
}

/* ── KPI cards ─────────────────────────────── */
.kpi-card {
  background: #fff;
  border-radius: 12px;
  padding: 0.9rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  border-left: 4px solid var(--kpi-color);
  transition: transform 0.2s, box-shadow 0.2s;
}
.kpi-card:hover { transform: translateY(-2px); box-shadow: 0 6px 18px rgba(0,0,0,0.1); }
.kpi-icon {
  font-size: 1.6rem;
  color: var(--kpi-color);
  min-width: 36px;
  text-align: center;
}
.kpi-body { display: flex; flex-direction: column; min-width: 0; }
.kpi-label { font-size: 0.7rem; color: #888; text-transform: uppercase; letter-spacing: .03em; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.kpi-value { font-size: 1.1rem; font-weight: 700; color: var(--kpi-color); white-space: nowrap; }

/* ── Alert stat cards ──────────────────────── */
.alert-stat-card {
  background: #fff;
  border-radius: 12px;
  padding: 0.9rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  border: 1px solid #f1f1f1;
  transition: transform 0.2s;
}
.alert-stat-card:hover { transform: translateY(-2px); }
.alert-danger   { border-left: 4px solid #dc3545; }
.alert-warning  { border-left: 4px solid #ffc107; }
.alert-success  { border-left: 4px solid #198754; }
.alert-info     { border-left: 4px solid #0dcaf0; }
.alert-primary  { border-left: 4px solid #0d6efd; }
.alert-secondary{ border-left: 4px solid #6c757d; }
.alert-icon { font-size: 1.5rem; min-width: 32px; text-align: center; }
.alert-danger   .alert-icon { color: #dc3545; }
.alert-warning  .alert-icon { color: #ffc107; }
.alert-success  .alert-icon { color: #198754; }
.alert-info     .alert-icon { color: #0dcaf0; }
.alert-primary  .alert-icon { color: #0d6efd; }
.alert-secondary .alert-icon { color: #6c757d; }
.alert-body { display: flex; flex-direction: column; min-width: 0; }
.alert-value { font-size: 1.1rem; font-weight: 700; }
.alert-label { font-size: 0.7rem; color: #888; text-transform: uppercase; letter-spacing: .03em; }

/* ── Payment methods progress ──────────────── */
.payment-method-row { }
.progress { border-radius: 20px; background: #f0f0f0; }

/* ── Text colour helpers ───────────────────── */
.text-purple { color: #6610f2 !important; }
</style>
